import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useCallback, useContext, useMemo } from 'react';

import { Color } from '@/constants/color';
import AppContext from '@/contexts/appContext';
import DisabledTooltip from '@/pages/RewardCardList/components/DisabledTooltip';
import RewardCardRepository from '@/repositories/RewardCardRepository';
import Button from '@/ui/components/Button';
import mapAxiosErrorMessages from '@/utils/mapAxiosErrorMessages';

import { Props } from './types';
const TerminateButton = ({ accountId, disabled = false }: Props) => {
  const { addMessage } = useContext(AppContext);
  const rewardCardRepository = RewardCardRepository();

  const { isPending, mutate } = useMutation({
    mutationFn: rewardCardRepository.terminateAccount,
    onSuccess: () => {
      addMessage('success', 'Account terminated successfully');
    },
    onError: (error: AxiosError) => {
      addMessage(mapAxiosErrorMessages(error));
    }
  });

  const handleClick = useCallback(() => {
    return confirm('This action is irreversible. Are you sure you want to terminate this account?')
      ? mutate(accountId)
      : null;
  }, [accountId, mutate]);

  const renderButton = useMemo(() => {
    return (
      <Button color={Color.RED} disabled={isPending || disabled} onClick={handleClick} size="xs">
        {isPending ? 'Terminating...' : 'Terminate'}
      </Button>
    );
  }, [disabled, handleClick, isPending]);

  return <>{disabled ? <DisabledTooltip>{renderButton}</DisabledTooltip> : renderButton}</>;
};

export default TerminateButton;
